import { PanelResultDetails } from "../../store/slices/order/types";
import { formatCultureResultData } from "../../utils/result.utils";

function PdfCulture({
    resultDetails
}: {
    resultDetails: PanelResultDetails
}) {
    const organismResults = formatCultureResultData(resultDetails?.strValue);
    return (
        <>
            {organismResults.map((organism, index) => (
                <div key={index} className="mb-4">
                    <p className="text-left text-[15px] font-[700] mb-2 uppercase">{resultDetails?.name.replace('/',"  /  ")}</p>
                    <p className="font-[500] border-y-[1px] border-black pb-2 capitalize">{organism.name?.toLowerCase()}</p>

                    <table width='100%' >
                        <thead className="border-b-[1px] border-black pb-2 grid grid-cols-5 text-[12px] pt-0">
                            <th className="col-span-3 pt-0">TEST NAME</th>
                            <th className="">RESULT</th>
                        </thead>
                        <tbody>
                            <tr className="grid grid-cols-5">
                                <td className="flex items-center col-span-3 justify-start gap-32"> <span>{organism.orgNumber?.replace('Org', 'Organism ')} : </span>  <span className="capitalize">{organism?.name?.toLowerCase()}</span></td>
                                <td className="flex items-center justify-start gap-32"> <p>Growth:</p>   <p>{organism.growth}</p></td>
                            </tr>
                            <tr className="mb-2 pb-3">
                                <td className="pb-3">Antibiotics</td>
                            </tr>
                            <tr className="border-[1px] border-black grid grid-cols-5 pm-4 pb-3">
                                <p className=" col-start-3" >{organism.orgNumber}</p>
                                {organism.sensitivity.map((sensitivity) => (
                                    <tr className="col-span-5 grid grid-cols-5" key={sensitivity.antibiotic}>
                                        <td className="text-[0.875rem] pl-2 col-span-2 font-[500]">
                                            {sensitivity?.antibiotic}
                                        </td>
                                        <td className="col-span-3 text-[0.875rem]  font-[500]">
                                            {sensitivity?.reaction}
                                        </td>
                                    </tr>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>))}
        </>


    );
}

export default PdfCulture;